import { NgModule, NgModuleRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { ContentModule } from '@awp/content';
import { CommonUiModule } from '@awp/common';
import { CardCheckApiModule } from '@awp/nac/card-check/api';

import { COMPONENTS, ENTRY_COMPONENTS } from './components';
import { DynamicOutletRegistryService, DynamicOutletModule } from '@awp/dynamic-outlet';
import { COMPONENT_REGISTER } from './card-check.registry';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ContentModule,
    DynamicOutletModule,
    CommonUiModule,
    CardCheckApiModule,
    RouterModule.forChild([]),
  ],
  declarations: [...COMPONENTS],
  entryComponents: [...ENTRY_COMPONENTS]
})
export class CardCheckUiModule {

  constructor(
    moduleRef: NgModuleRef<CardCheckUiModule>,
    dynamicOutletRegistry: DynamicOutletRegistryService) {
    dynamicOutletRegistry.register(CardCheckUiModule.name, COMPONENT_REGISTER, moduleRef);
  }

}
